import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

export const GeneratedPasswordModal = ({ username, password, onClose }) => {
    const { darkMode } = useTheme();

    const copyToClipboard = () => {
        navigator.clipboard.writeText(password)
            .then(() => alert('✅ Пароль скопирован в буфер обмена!'))
            .catch(() => alert('❌ Не удалось скопировать пароль. Скопируйте вручную.'));
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={onClose}
        >
            <div
                className={`rounded-xl shadow-2xl w-full max-w-md p-6 ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                }`}
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-start mb-4">
                    <div className="flex items-center space-x-3">
                        <div className={`${darkMode ? 'bg-green-900' : 'bg-green-100'} p-2 rounded-lg`}>
                            <CheckCircle className={`w-6 h-6 ${darkMode ? 'text-green-400' : 'text-green-600'}`} />
                        </div>
                        <div>
                            <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                                Пароль успешно сгенерирован!
                            </h2>
                            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                Для пользователя: <strong>{username}</strong>
                            </p>
                        </div>
                    </div>
                    <button onClick={onClose} className={darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}>
                        <X className="w-6 h-6" />
                    </button>
                </div>

                <div className="space-y-4">
                    <div className="relative">
                        <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Сгенерированный пароль:
                        </label>
                        <div className={`flex items-center p-3 rounded-lg ${
                            darkMode ? 'bg-gray-700 border border-gray-600' : 'bg-white border border-gray-300'
                        }`}>
                            <input
                                type="text"
                                value={password}
                                readOnly
                                className={`w-full font-mono font-bold text-lg text-center px-2 py-1 ${
                                    darkMode ? 'bg-gray-700 text-green-400' : 'bg-white text-green-700'
                                }`}
                            />
                            <button
                                onClick={copyToClipboard}
                                className={`ml-3 p-2.5 rounded-lg transition-colors ${
                                    darkMode ? 'bg-blue-900 hover:bg-blue-800 text-blue-300' : 'bg-blue-100 hover:bg-blue-200 text-blue-700'
                                }`}
                                title="Скопировать пароль"
                            >
                                <Copy className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    <div className={`p-3 rounded-lg ${
                        darkMode ? 'bg-yellow-900/30 border border-yellow-800' : 'bg-yellow-50'
                    }`}>
                        <p className={`text-xs ${darkMode ? 'text-yellow-300' : 'text-yellow-800'}`}>
                            ⚠️ <strong>ВАЖНО:</strong> Обязательно сообщите этот пароль пользователю! После закрытия этого окна пароль будет недоступен.
                        </p>
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className={`px-5 py-2.5 rounded-lg font-medium transition-colors ${
                                darkMode ? 'bg-green-700 hover:bg-green-600 text-white' : 'bg-green-600 hover:bg-green-700 text-white'
                            }`}
                        >
                            Понятно, закрыть
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};